import React, { useEffect } from "react";
import { useShoppingContext } from "../../../../context/ShoppingContext";

const DetallesProduccion = ({ selectedProduccion }) => {
  const { tiposHuevosProduccion, getTipoHuevoByProduccionId } = useShoppingContext();

  useEffect(() => {
    if (selectedProduccion) {
      // Llamar a la función para obtener los tipos de huevos por producción
      getTipoHuevoByProduccionId(selectedProduccion.id);
    }
  }, [selectedProduccion, getTipoHuevoByProduccionId]);

  return (
    <div>
      <h4>Detalles de Producción</h4>
      {tiposHuevosProduccion.map((tipo) => (
        <div key={tipo.TipoHuevo.id}>
          <p>{tipo.TipoHuevo.nombre}: {tipo.cantidad} unidades</p>
        </div>
      ))}
    </div>
  );
};

export default DetallesProduccion;
